import { render } from "./signaturesToken.vue?vue&type=template&id=5fdea646"
import script from "./signaturesToken.vue?vue&type=script&lang=ts"
export * from "./signaturesToken.vue?vue&type=script&lang=ts"
script.render = render

export default script